import React, { useState, useEffect, useRef } from 'react';
import { Input, Button, Typography, DatePicker, Image, Result, TimePicker, Switch, Tooltip } from 'antd'
import { useScreenSize } from '../../../hooks/useScreenSize';
import { apiAddEvent, apiUploadEventMessage, apiUploadEventPhoto } from '../../../utils/api';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/es_ES';
import { LocationEvent } from './LocationEvent';
import { UploadOutlined, DeleteFilled } from '@ant-design/icons';
import { prMain } from '../../../themeConfig';
import { CreateMessages } from './CreateMessages';

const CreateEvent = ({ setOpenCreate, refresh, setRefresh, setOpenDetails, setDetails }) => {
    const { Text } = Typography
    const { height } = useScreenSize()
    const [loading, setloading] = useState(false)

    const [dateEvent, setDateEvent] = useState(new Date())
    const [finalDateEvent, setFinalDateEvent] = useState(new Date())
    const datePickerRef = useRef(null);

    const [checkedAt, setCheckedAt] = useState(moment(new Date()).subtract(1, 'hour').format())
    const [startTime, setStartTime] = useState(new Date())
    const [endTime, setEndTime] = useState(moment(new Date()).add(1, 'hour').format())
    
    const [step, setStep] = useState(0)
    const [values, setValues] = useState([])
    const [location, setLocation] = useState([])
    const [img, setImg] = useState("")
    const [success, setSuccess] = useState(false)
    const [urlImg, setUrlImg] = useState("")

    const [messageImg, setMessageImg] = useState(null)
    const [urlMessageImg, seturlMessageImg] = useState("")

    const [imageChanged, setimageChanged] = useState(false)
    const [qrRequired, setqrRequired] = useState(true)
    const [notification, setNotification ] = useState(false)


    const handleSuccess = () => {
        setSuccess(true)
        setStep(2)
        setRefresh(!refresh)
    }

    const handleSubmit = () => {
        let data = {
            "eventName": values.eventName,
            "description": values.description,
            "place": values.place,
            "startTime": `${moment(startTime).format().toString().slice(0,-6)}`,
            "endTime": `${moment(endTime).format().toString().slice(0,-6)}`,
            "address": location.address,
            "latitude": location.latitude,
            "longitude": location.longitude,
            "checkedAt": `${moment(checkedAt).format().toString().slice(0,-6)}`,
            "qrRequired": qrRequired
        }

        if(!imageChanged){
            data = {...data, "title": values.title, "message": values.message, "footImage": urlMessageImg}
        }

        setloading(true)
        apiAddEvent(data, notification).then((response) => {

            if (imageChanged) {

                apiUploadEventMessage(response.data.idEvent, messageImg, values.title, values.message).then(res => {
                    console.log(res)
                }).catch(err => {
                    new Error(err)
                })
            }

            img ?
                apiUploadEventPhoto(response.data.idEvent, img).then((res) => {
                    handleSuccess()
                }).catch(error => {
                    console.log(error)
                    setDetails(response.data)
                    setSuccess(false)
                    setStep(3)
                })
                : handleSuccess()
        }).catch(error => {
            console.log(error)
            setSuccess(false)
            setStep(2)
        }).finally(() => {
            setloading(false)
        })

    }

    const handleChange = (event, key) => {
        setValues({ ...values, [key]: event.target.value })
    }

    const handleImage = (e) => {

        if (!e) return

        setImg(e.target.files[0])
        setUrlImg(URL.createObjectURL(e.target.files[0]))
    }

    const handleMessageImage = (e) => {

        if (!e) return

        setimageChanged(true)

        setMessageImg(e.target.files[0])
        seturlMessageImg(URL.createObjectURL(e.target.files[0]))

    }

    const handleRemoveMessageImg = (name) => {

        document.getElementById(name).value = "";

        setMessageImg(null)
        seturlMessageImg("")
    }

    const handleRemoveImage = (name) => {

        document.getElementById(name).value = "";

        setImg("")
        setUrlImg("")
    }

    const handleEdit = () => {
        setOpenDetails(true)
        setOpenCreate(false)
    }

    const onChangeSwitch = (e) => {
        setqrRequired(e)
    }

    const changeNotification = (e) => {
        setNotification(e)
    } 

    const handleSetDateEvent = (event) => {
        setDateEvent(event)

        handleSetStartTime(event, event)
        handleSetCheckin(event, new Date(moment(event).subtract(1, 'hour').format()))

    } 

    const handleSetFinalDateEvent = (event) => {
        setFinalDateEvent(event)
        handleSetEndTime(event, new Date(moment(event).add(1, 'hour').format()))

    } 

    const handleSetStartTime = (date, hr) => {
        let hour = moment(hr).format('LTS').toString().length < 8 ? `0${moment(hr).format('LTS').toString()}` : moment(hr).format('LTS').toString()
        setStartTime(new Date(`${moment(date).format('YYYY-MM-DD')}T${hour}`))

    }

    const handleSetEndTime = (date, hr) => {
        let hour = moment(hr).format('LTS').toString().length < 8 ? `0${moment(hr).format('LTS').toString()}` : moment(hr).format('LTS').toString()
        setEndTime(new Date(`${moment(date).format('YYYY-MM-DD')}T${hour}`))

    }

    const handleSetCheckin = (date, hr) => {
        let hour = moment(hr).format('LTS').toString().length < 8 ? `0${moment(hr).format('LTS').toString()}` : moment(hr).format('LTS').toString()
        setCheckedAt(new Date(`${moment(date).format('YYYY-MM-DD')}T${hour}`))

    }

    return (
        <div style={{ width: '100%' }}>
            <div style={classes.a}>
                {
                    !success &&
                    <Text style={{ fontSize: '1.5rem' }}>Crear Evento</Text>
                }
            </div>
            {
                step === 0 &&
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <section style={{ display: 'flex', flexDirection: 'row', gap: '3rem' }}>
                        <div style={{ width: 'fit-content', justifyContent: 'center' }}>
                            <label style={{ backgroundColor: prMain }} className='input-container' >
                                <UploadOutlined style={{ marginRight: 10 }} />
                                <input
                                    id={'eventImageInput'}
                                    className='inputSelect'
                                    type="file"
                                    onChange={handleImage}
                                />
                                {`Seleccionar Imagen (Opcional)`}
                            </label>
                            <div style={{ height: 'fit-content', maxHeight: 300, display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 15 }}>
                                {
                                    urlImg
                                        ?
                                        <>
                                            <Image id={'eventImage'} src={urlImg} alt={'Imagen del evento'} height={300} style={{ objectFit: 'cover' }} />
                                            {/* <Button icon={<DeleteFilled />} type='link' onClick={() => handleRemoveImage()}>Remover</Button> */}
                                        </>
                                        :
                                        <Image
                                            style={{ objectFit: 'cover' }}
                                            width={'100%'}
                                            height={300}
                                            src="error"
                                            fallback="data:image/png;base64,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"
                                        />
                                }
                                {urlImg && <Button icon={<DeleteFilled />} type='link' onClick={() => handleRemoveImage('eventImageInput')}>Remover</Button>}
                            </div>
                        </div>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between' }}>

                            <div style={{ position: 'relative' }}>
                                <label style={{ fontSize: '1rem', opacity: 0.6 }}>Boleto Digital</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'center' }}>

                                    <Switch checked={qrRequired} onChange={onChangeSwitch} />
                                    {
                                        qrRequired ? (
                                            <div>
                                                Si
                                            </div>
                                        ) : (
                                            <div>
                                                No
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div style={{ position: 'relative' }}>
                                <label style={{ fontSize: '1rem', opacity: 0.6 }}>Enviar notificación</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'center' }}>

                                    <Switch checked={notification} onChange={changeNotification} />
                                    {
                                        notification ? (
                                            <div>
                                                Si
                                            </div>
                                        ) : (
                                            <div>
                                                No
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>

                            <div style={{ display: 'flex', gap: '1.5rem', flexDirection: height > 600 ? 'column' : 'row' }}>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <label style={{ fontSize: '1rem', opacity: 0.6 }}>Nombre del evento *</label>
                                    <Input
                                        id='eventName'
                                        name='eventName'
                                        onChange={(e) => handleChange(e, "eventName")}
                                        value={values.eventName}
                                        style={{ height: 40 }}
                                        size='large'
                                        placeholder='Ingrese el nombre del evento'
                                    />
                                </div>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <label style={{ fontSize: '1rem', opacity: 0.6 }}>Descripción *</label>
                                    <Input.TextArea
                                        id='description'
                                        name='description'
                                        onChange={(e) => handleChange(e, "description")}
                                        value={values.descriptions}
                                        style={{ height: 80, resize: 'none' }}
                                        size='large'
                                        placeholder='Ingrese la descripción del evento'
                                    />
                                </div>
                            </div>
                            <div style={{ position: 'relative' }}>
                                <label style={{ fontSize: '1rem', opacity: 0.6 }}>Lugar *</label>

                                <Input
                                    id='place'
                                    name='place'
                                    onChange={(e) => handleChange(e, "place")}
                                    value={values.place}
                                    style={{ height: 40 }}
                                    size='large'
                                    max={10}
                                    placeholder='Ingrese el lugar'
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                                    <label style={{ fontSize: '1rem', opacity: 0.6 }}>Fecha y hora inicial * </label>
                                        <div style={{ display: 'flex', WebkitFlexDirection: 'column' , gap: '1rem'}}>
                                            <DatePicker
                                                id="dateEvent"
                                                name="dateEvent"
                                                format='DD-MM-YYYY'
                                                allowClear={false}
                                                locale={locale}
                                                value={moment(dateEvent)}
                                                onChange={(e) => handleSetDateEvent(e)}
                                            />
                                        <div style={{ display: 'flex', WebkitFlexDirection: 'row', gap: '1rem' }}>

                                            <Tooltip title="Inicio del evento" placement="bottom">
                                                <TimePicker
                                                    allowClear={false}
                                                    format='HH:mm'
                                                    id='startTime'
                                                    name='startTime'
                                                    locale={locale}
                                                    value={moment(startTime)}
                                                    onChange={(e) => handleSetStartTime( dateEvent , e)}
                                                />
                                            </Tooltip>
                                        </div>
                                    <label style={{ fontSize: '1rem', opacity: 0.6 }}>Fecha y hora final * </label>
                                        <div style={{ display: 'flex', WebkitFlexDirection: 'column' , gap: '1rem'}}>
                                            <DatePicker
                                                id="dateEvent"
                                                name="dateEvent"
                                                format='DD-MM-YYYY'
                                                allowClear={false}
                                                locale={locale}
                                                value={moment(finalDateEvent)}
                                                onChange={(e) => handleSetFinalDateEvent(e)}
                                            />
                                        <div style={{ display: 'flex', WebkitFlexDirection: 'row', gap: '1rem' }}>
                                            <Tooltip title="Fin del evento" placement="bottom">

                                                <TimePicker
                                                    allowClear={false}
                                                    format='HH:mm'
                                                    id='endTime'
                                                    name='endTime'
                                                    locale={locale}
                                                    value={moment(endTime)}
                                                    onChange={(e) => handleSetEndTime( finalDateEvent , e)}
                                                />
                                            </Tooltip>
                                        </div>
                                    </div>
                                { (startTime > endTime) &&
                                <div style={{ width: '250px', display: 'flex', justifyContent: 'center' }}>
                                    <label style={{ fontSize: '0.6rem', opacity: 0.6, textAlign: 'center', color: 'red' }}>
                                        Las horas no están en el orden correcto
                                    </label>
                                    </div>
                                }
                                    </div>
                                </div>
                                <div style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                                    <label style={{ fontSize: '1rem', opacity: 0.6 }}>Inicio de Check-in *</label>
                                    <TimePicker
                                        allowClear={false}
                                        format='HH:mm'
                                        id='checkin'
                                        name='checkin'
                                        locale={locale}
                                        value={moment(checkedAt)}
                                        onChange={(e) => handleSetCheckin( dateEvent , e)}
                                    />
                                    { (checkedAt > endTime) &&
                                     <div style={{ width: '120px', display: 'flex', justifyContent: 'center' }}>
                                     <label style={{ fontSize: '0.6rem', opacity: 0.6, textAlign: 'center', color: 'red' }}>
                                         Check-in está después del final del evento
                                     </label>
                                     </div>
                                    }
                                </div>
                            </div>
                        </div>

                    </section>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                        <Button type='link' onClick={() => setOpenCreate(false)}>
                            Cancelar
                        </Button>
                        <Button disabled={!values.eventName ||
                            !values.description ||
                            !values.place ||
                            !dateEvent ||
                            !finalDateEvent ||
                            !startTime ||
                            !endTime ||
                            (startTime > endTime) ||
                            (checkedAt > endTime) ||
                            !checkedAt}
                            type='primary' onClick={() => setStep(1)}>
                            Siguiente
                        </Button>
                    </div>
                </div>
            }
            {
                step === 1 &&
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <LocationEvent setLocation={setLocation} />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                        <Button type='link' onClick={() => { setStep(0); setLocation([]) }}>
                            Atrás
                        </Button>
                        <Button loading={loading} disabled={location.length === 0} type='primary' onClick={() => { setStep(4) }}>
                            Siguiente
                        </Button>
                    </div>
                </div>
            }
            {
                step === 4 &&
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <CreateMessages seturlMessageImg={seturlMessageImg} values={values} setvalues={setValues} handleChange={handleChange} handleImage={handleMessageImage} handleRemoveImage={handleRemoveMessageImg} urlImg={urlMessageImg} />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                        <Button type='link' onClick={() => { setStep(1) }}>
                            Atrás
                        </Button>
                        <Button loading={loading} disabled={!values.title || !values.message || !urlMessageImg} type='primary' onClick={handleSubmit}>
                            Guardar
                        </Button>
                    </div>
                </div>
            }
            {
                step === 2 &&
                (
                    success
                        ?
                        <Result
                            status='success'
                            title='Evento creado'
                            subTitle={'El evento ha sido creado exitosamente'}
                            extra={[
                                <Button key='ok' type='primary' onClick={() => setOpenCreate(false)} autoFocus >
                                    Aceptar
                                </Button>
                            ]}
                        />
                        :
                        <Result
                            status='error'
                            title='Error en la petición'
                            subTitle={"Se ha producido un error en la petición. Por favor, intente nuevamente."}
                            extra={[
                                <Button style={{ marginTop: 15 }} key='exit' type='primary' onClick={() => setOpenCreate(false)} autoFocus >
                                    Salir
                                </Button>
                            ]}
                        />
                )
            }
            {
                (step === 3 && !success && img) &&
                <Result
                    status="warning"
                    title='Evento creado sin foto'
                    subTitle={`El evento ha sido creado correctamente, pero se ha producido un error al cargar la foto. En Editar evento podrá intentar subir la foto nuevamente.`}
                    extra={[
                        <>
                            <Button style={{ marginTop: 15 }} key='exit' type='link' onClick={() => setOpenCreate(false)} >
                                Salir
                            </Button>
                            <Button style={{ marginTop: 15 }} key='edit' type='primary' onClick={() => handleEdit()} autoFocus >
                                Editar evento
                            </Button>
                        </>

                    ]}
                />
            }
        </div>

    );
}

const classes = {
    button: {
        textTransform: 'capitalize',
        width: '50%',
        height: '50px',
        fontSize: '15px',
        fontWeight: 'bold',
    },
    root: {
        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)',
        height: 'auto',
        overflowY: 'auto',
        background: '#fafafa',
        borderRadius: '3%',
        display: 'flex',
        flexDirection: 'flex',
        justifyContent: 'center',
        padding: '20px',
        margin: '10%'
    },
    logo: {
        width: 100,
    },
    buttons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        '& > *': {
        },
    },
    a: {
        justifyContent: "center",
        alignItems: "center",
        display: 'flex',
        marginBottom: 20
    },
    btnFacebook: {
        display: 'flex',
        justifyContent: 'space-evenly',
        '& > *': {
        },
    },
}

export default CreateEvent

